import BackendService from './BackendService';
import { getMfaSessionToken, getToken, setToken } from '../util/tokenUtils';

export default class AuthService {
  static login(body) {
    return BackendService.post('/users/login', { body });
  }

  /**
   * Redirect the user to the Okta login screen.
   *
   * @returns {void}
   */
  static oktaRedirect(email) {
    const options = email ? { params: { email } } : {};
    const useToken = false;
    const url = BackendService.getFullUrl(`/oidc/chairman`, options, useToken);

    if (!url) {
      throw new Error('Missing url');
    }

    // Redirect the user
    window.location.href = url;
  }

  /**
   * Verify the code and state with the backend service
   *
   * @param {{code: string; state: string;}} body
   * @returns {Promise<User>}
   */
  static oktaLogin(body) {
    return BackendService.post('/oidc/verify', { body });
  }

  /**
   * Check if Okta is required for the user
   *
   * @param {{email: string}} body
   * @returns {Promise<{oidcRequired: boolean}>}
   */
  static oktaRequired(body) {
    return BackendService.post('/oidc/required', { body });
  }

  static mfaLogin(body) {
    const mfaSessionToken = getMfaSessionToken();

    if (mfaSessionToken) {
      const headers = {
        Authorization: `Bearer ${mfaSessionToken}`,
      };
      return BackendService.post('/users/mfalogin', { body, headers });
    }

    return BackendService.post('/users/mfalogin', { body });
  }

  static multiFactor(payload) {
    const body = {
      rememberDevice: payload.rememberDevice,
      otp: payload.otp,
    };

    const headers = {
      Authorization: `Bearer ${payload.mfaToken}`,
    };

    return BackendService.post('/users/multiFactor', { body, headers });
  }

  static resendOtp(payload) {
    const headers = {
      Authorization: `Bearer ${payload.mfaToken}`,
    };

    return BackendService.post('/users/resendOtp', { headers });
  }

  static updateSession(dealerId) {
    return BackendService.put('/users/session', { body: { dealerId } });
  }

  static getCurrentUser() {
    return BackendService.get('/users/currentUserInfo');
  }

  static getDealers() {
    return BackendService.get('/users/dealers');
  }

  static setToken(token) {
    return setToken(token);
  }

  static getToken() {
    return getToken();
  }

  static isLoggedIn() {
    return !!AuthService.getToken();
  }

  static logout() {
    return BackendService.post('/users/logout');
  }
}
